import type { AttachmentWellViewState } from 'owa-attachment-well-data';
import { logUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';

let registeredCallback:
    | ((conversationId: string, itemId: string) => AttachmentWellViewState | null)
    | null = null;

const getAttachmentWellViewStateByItemIdHelper = {
    register: (
        callback: (conversationId: string, itemId: string) => AttachmentWellViewState | null
    ): void => {
        registeredCallback = callback;
    },
    available: (): boolean => !!registeredCallback,
    run: (
        conversationId: string,
        itemId: string,
        mailboxInfo: MailboxInfo
    ): AttachmentWellViewState | null => {
        if (registeredCallback) {
            return registeredCallback(conversationId, itemId);
        } else {
            logUsage('CnexErrorAttachmentWellGetterNotRegistered', mailboxInfo);
            return null;
        }
    },
};

export { getAttachmentWellViewStateByItemIdHelper };
